import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withTheme } from 'styled-components';
import {
  clearUpdateData,
  clearSerializedData,
  setSerializedData,
  setBillboardImages,
} from 'store/actions/canvasActions';
import { addMessage, clearMessages } from 'store/actions/appActions';
import Canvas from '@archvisioninc/canvas';
import _ from 'lodash';

const FOVEACanvas = withTheme(props => {
  const { theme, previewURL } = props;

  const dispatch = useDispatch();
  const canvasStore = useSelector(state => state.canvas);
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;
  const messages = appStore.messages;
  const defaultEnvironments = canvasStore.defaultEnvironments;
  const reinitializeCanvas = canvasStore.reinitializeCanvas;
  const updateData = useMemo(() => canvasStore.updateData, [ canvasStore ]);
  const integrationOptions = { shadows: false };

  if (!previewURL) return null;

  return (
    <Canvas
      data-testid='archvisionCanvas'
      theme={theme}
      $selectedTheme={selectedTheme}
      integration={integrationOptions}
      notifications={messages}
      defaultEnvironments={defaultEnvironments}
      addNotification={(messages, clearExisting) => dispatch(addMessage([ ...messages ], clearExisting))}
      clearNotifications={() => dispatch(clearMessages())}
      clearUpdateData={() => dispatch(clearUpdateData())}
      file={null}
      guidURL={previewURL}
      updateData={updateData}
      reinitialize={reinitializeCanvas}
      toDownload={false}
      setSerializedData={data => {
        const cleanData = JSON.stringify(data);
        dispatch(clearSerializedData());
        dispatch(setSerializedData(cleanData));
      }}
      setBillboardImages={newArray => {
        if (!_.isEmpty(newArray)) {
          dispatch(setBillboardImages(newArray));
        }
      }}
      previewMode={true}
    />
  );
});

export { FOVEACanvas };

